(ns teamoesterreich.user-mode.warnings.warning-overview
  (:require [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            [teamoesterreich.config :as config]
            [teamoesterreich.firebase.fb-warning :as fb-warning]
            [teamoesterreich.firebase.provider :as provider]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.actions :as a]
            ))



(defn card [locationId isMain]
  (let [
        !location (r/cursor store/app-state [:locations locationId])
        !selected-location (r/cursor store/app-state [:state :selected-location])
        location @!location
        cnt-warnings (fb-warning/count-actual-location-warnings locationId)
        lat (and (get-in location [:coordinates]) (.-_lat ^js (get-in location [:coordinates])))
        lng (and (get-in location [:coordinates]) (.-_long ^js (get-in location [:coordinates])))]

    [mui/card
     {:style   {:marginTop "5px" :marginBottom "15px" :cursor "hand"}
      :onClick (fn []
                 (reset! !selected-location locationId)
                 (a/set-page :warning-location))}
     [mui/card-content
      {:style {:display "flex" :flexDirection "row"}}
      [mui/card-media
       {:component "img"
        :style     {:flex "0 1 400px"}
        :image     (or (when-not (= "" (:location-picture-path-fst location)) (:location-picture-path-fst location))
                       (and lat lng
                            (str "https://maps.googleapis.com/maps/api/staticmap?"
                                 "center=" lat "," lng "&zoom=14&size=400x300&"
                                 "markers=color:red|" lat "," lng
                                 "&key=" config/GOOGLE_MAPS_API "&"
                                 ))
                       "/custom/img/home.png")
        :width     "300"
        :height    "200"
        :onClick   (fn []
                     (reset! !selected-location locationId)
                     (a/set-page :prevent-locationView))
        :title     (str (get-in location [:name]))
        :alt       (str (get-in location [:name]))
        }]


      [mui/card-content
       {:style {:flex "1 0 auto"}}
       [mui/typography {:variant "h5" :component "h5"}
        (str (get-in location [:name]))]
       [:br]
       (when isMain
         [mui/typography {:variant "h5" :component "h5" :color "primary"} "Wohnadresse"])
       [:br]
       [mui/typography {:variant "body2" :component "p" :color "textSecondary"}
        (str (get-in location [:address]))]
       [:br]
       ]
      ]

     [mui/card-content
      {:style {:textAlign "center"}}
      [mui/typography {:variant "h5" :component "h5"
                       :style   {:color (if (> cnt-warnings 0) "red" "#385738")}}
       (case cnt-warnings
         0 "Es wurden keine Warnungen für diesen Standort gefunden"
         1 "Es wurde eine Warnung für diesen Standort gefunden"
         (str "Es wurden " cnt-warnings " Warnungen für diesen Standort gefunden"))
       ]]

     ]))

(defn get-it_ []
  [:h1 "In Arbeit"])


(defn get-it []
  (fn []
    (let [!location-list (r/cursor store/app-state [:locations])
          fav-location (provider/get-fav-locationId)]
      ;(log/out "Location-card " (clj->js location-list))
      [mui/grid
       {
        :container  true
        :direction  "row"
        :justify    "center"
        :alignItems "center"
        :spacing    1
        }

       [mui/grid
        {:container false
         :item      true
         :lg        7
         :xs        11

         }
        [mui/grid
         {:container  true
          :direction  "row"
          :justify    "space-between"
          :alignItems "center"
          :spacing    3
          }
         [mui/grid
          {:container false
           :item      true
           :lg        12
           :xs        12

           }
          [:br]
          [mui/typography {:variant "h4"} "Meine Standorte"]
          ]

         (doall (for [[locationId location] (sort-by (fn [[id obj]] (if (= fav-location id) 0 1)) @!location-list)]
                  (do
                    ^{:key (str "location-" locationId)}
                    [mui/grid
                     {:container false
                      :item      true
                      :lg        12
                      :xs        12

                      }
                     ;locationId
                     (card locationId (= fav-location locationId))

                     ])))



         [mui/grid
          {:container false
           :item      true
           :xs        6

           }

          [mui/button
           {:variant   "contained"
            :color     "default"
            :class     "bottom-button"
            :onClick   #(a/set-page-back)
            :startIcon (r/as-element [keyboard-arrow-left])
            }
           "Zurück"]]

         [mui/grid
          {:container false
           :item      true
           :xs        6

           }
          [mui/button
           {:variant   "contained"
            :color     "primary"
            :onClick   #(a/set-page :warning-locationCreate)
            :startIcon (r/as-element [add])
            }
           "Neuer Standort"]]

         ]]
       ]

      )))